module.exports = __webpack_public_path__ + "static/img/DE.4379c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/DE.png
// module id = QyDD
// module chunks = 1